import { useContext } from 'react';

import { Paragraph, Tooltip, TriggerText } from '@zillow/constellation-10';

import { RoutingSelectors } from '../../../../selectors';
import { useSelector } from '../../../../selectors/useSelector';

import propertyUtils from '../../../../utils/propertyUtils';
import { useGetPremiumOverview } from '../../../../hooks/queries/freemium';

import { FreemiumContext } from '../../context';

type ActiveCompsTooltipProps = {
  triggerText: string;
};

const ActiveCompsTooltip = ({ triggerText }: ActiveCompsTooltipProps) => {
  const {
    freemiumState: {
      filters: { beds, filterType, propertyType },
    },
  } = useContext(FreemiumContext);

  const listingId = useSelector((state) => RoutingSelectors.makeListingId(state));

  const { data: overviewData } = useGetPremiumOverview({ listingId });

  if (!overviewData) {
    return null;
  }

  const { formattedCityState } = propertyUtils.formatAddress(overviewData);
  const searchArea = filterType === 'zip' ? overviewData.zip : formattedCityState;
  const searchString = propertyUtils.formatSearchString(beds, propertyType, searchArea, false);

  return (
    <Tooltip.Root placement="top">
      <Tooltip.Trigger>
        <TriggerText>{triggerText}</TriggerText>
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content>
          <Paragraph>{`Matching your filters for ${searchString}`}</Paragraph>
          <Tooltip.Arrow />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
};

export default ActiveCompsTooltip;
